import IService from "@api/iService";
import { IGoal, IRefCode, IRefStat } from "@interfaces/user/refs";

export default class RefService extends IService {

    async getGoals() {
        return await this.getApi<IGoal[]>('/api/user/goals/');
    }

    async getGoal(goalId: string) {
        return await this.getApi<IGoal>(`/api/user/goals/${goalId}/`);
    }

    getRefCode() {
        return this.getApi<IRefCode>('/api/user/refs/');
    }

    createRefCode() {
        return this.postApi<IRefCode>('/api/user/refs/create/');
    }

    getRefStats() {
        return this.getApi<IRefStat[]>('/api/user/refs/stats/')
    }
}